import { Card, Breadcrumb, Form, Col, Container, Row } from "@deere/ux.uxframe-react";
import { useLocation, useHistory, Link } from 'react-router-dom';
import { Button } from "@deere/ux.uxframe-react/lib/components/Button";
import { Fragment } from 'react';

export default function StatusSubmit() {
    const history = useHistory();
    const location = useLocation();

    const HandleStatusPageClick = () => {
        return window.open(`/Status/${location.state.material}/${location.state.requestorId}/${location.state.timestamp}/${location.state.flagFromPage}`,"_self")
    }

    const HandleSearchPageClick = () => {
        history.push({
            pathname: '/search'
        })
    }

    return (
        <Fragment>
            <title>PDC Parts Request Form (step 7)</title>
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >


                                    {location.state.flagFromPage === "requestlist" &&
                                        <Breadcrumb links={[{
                                            title: "Home",
                                            to: "/"
                                        }, {
                                            title: "Request List",
                                            to: "/"
                                        }, {
                                            title: "Status Approval",
                                            to: `/Status/${location.state.material}/${location.state.requestorId}/${location.state.timestamp}/${location.state.flagFromPage}`
                                            
                                        }, {
                                            title: "Status Confirmation"
                                        }]} label="breadcrumbs"
                                            breadcrumbItemProps={{ linkAs: Link }} />}

                                    {location.state.flagFromPage === "searchlist" &&
                                        <Breadcrumb links={[{
                                            title: "Home",
                                            to: "/"
                                        }, {
                                            title: "Search List",
                                            to: "/search"
                                        }, {
                                            title: "Status Approval",
                                            to: `/Status/${location.state.material}/${location.state.requestorId}/${location.state.timestamp}/${location.state.flagFromPage}`
                                            
                                        }, {
                                            title: "Status Confirmation"
                                        }]} label="breadcrumbs"
                                            breadcrumbItemProps={{ linkAs: Link }} />}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>



                    <h6 style={{ fontWeight: "bold" }}>PDC Parts Request Almost Completed</h6>




                    {
                        (location.state.status === 'D' || location.state.status === 'A' ? (location.state.status === 'D' ? (
                            location.state.emailTo !== '' ? <tbody> <tr>
                                <td>An Email has been sent to {location.state.emailTo}.The requestor has been copied.</td>
                            </tr></tbody> : <tbody> <tr>
                                <td>The requestor has been copied.</td>
                            </tr></tbody>) :
                            <tbody><tr>
                                <td>DY order {location.state.orderNum} for {location.state.actualQuantity} pieces of part {location.state.part} for {location.state.requestorName} is almost complete.</td>

                            </tr>
                                <tr>
                                    <td>The final email has been generated and still needs to be manually forwarded to the appropriate people.</td>
                                </tr>
                            </tbody>) : <tbody> <tr>
                                <td>This request has been saved</td>
                            </tr></tbody>)

                    }
                    <br /><br />

                    <Button variant="link" style={{ padding: 0, paddingBottom: 3 }} onClick={HandleStatusPageClick}> Link To Request</Button><br />
                    <Button variant="link" style={{ padding: 0, paddingBottom: 3 }} onClick={HandleSearchPageClick}>Search Page</Button>




                </Card.Body>
            </Card>
        </Fragment>
    )

}